import * as C from '../common/constants';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { ReactComponent as IconPropeller } from '../assets/icon_propeller.svg';
import LightModeIcon from '@mui/icons-material/LightMode';
import { EMenus } from '../common/enums';
import ThreeSixtyIcon from '@mui/icons-material/ThreeSixty';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import AnimationIcon from './AnimationIcon';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import FilterDramaIcon from '@mui/icons-material/FilterDrama';
import { useSelector, useDispatch } from 'react-redux';

const useStyles = makeStyles(
  (theme: any): StyleRules =>
    createStyles({
      settingsStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      animationConfigStyle: {
        padding: '10px',
        pointerEvents: 'auto',
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            opacity: 0.7,
            transition: '0.5s ease',
          },
        },
      },
    })
);

const ICONS = [
  {
    titleType: EMenus.ROTATION,
    actionType: C.SET_ROTATION,
    Icon: ThreeSixtyIcon,
  },
  {
    titleType: EMenus.SKY,
    actionType: C.SET_SKY,
    Icon: FilterDramaIcon,
  },
  {
    titleType: EMenus.PROPELLER,
    actionType: C.SET_PROPELLER,
    SVG: IconPropeller,
  },
  // {
  //   titleType: EMenus.PLATFORM,
  //   actionType: C.SET_PLATFORM,
  //   Icon: FormatUnderlinedIcon,
  // },
  {
    titleType: EMenus.WINGLIGHT,
    actionType: C.SET_WINGLIGHT,
    Icon: LightModeIcon,
  },
  // {
  //   titleType: EMenus.WHEELS,
  //   actionType: C.SET_WHEELS,
  //   Icon: FlightTakeoffIcon,
  // },
];

const AnimationConfiguration = (): JSX.Element => {
  const classes = useStyles();

  const appData = useSelector((state: any) => state.app[C.APP_DATA]);
  const config = appData?.config;

  if (!appData) {
    return null;
  }

  const ENABLED_ICONS = ICONS.filter((item) => {
    const iconId = item.titleType.toString();
    return config[iconId];
  });

  const getIcons = (data, index) => {
    return <AnimationIcon key={index} data={data} />;
  };

  return (
    <div className={classes.settingsStyle}>{ENABLED_ICONS.map(getIcons)}</div>
  );
};

export default AnimationConfiguration;
